import { DownloadOutlined, PlusOutlined, PrinterOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Row, Space, Table, Tag } from "antd";
import Column from 'antd/es/table/Column';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { trangThaiKPI } from '../../constants';
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon } from '../../helpers/common';
import { layDSKPICaNhan, layKPICaNhan } from '../../services/kpi';
import { xuatDanhGiaKetQuaKPI } from '../../services/report';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { useReactToPrint } from 'react-to-print';
import InKPICaNhan from './InKPICaNhan';
import TrangThaiTag from './TrangThaiTag';

const KPICaNhan = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [dataTable, setDataTable] = useState<any>();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([
        Links.KPI.ChiTietKPI,
        Links.KPI.ThemKPI,
    ]);
    let ngayHienTai = (dayjs()).date() <= 10 ? (dayjs()).subtract(1, 'month') : dayjs();
    let thangHienTai = ngayHienTai.startOf('month').format('DD/MM/YYYY HH:mm:ss'); 

    /*const [thangNam, setThangNam] = useState<string>(thangHienTai);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(ngayHienTai);*/
    const [thangNam, setThangNam] = useState<string>("");
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(null);
    const [chiTietKPICaNhan, setChiTietKPICaNhan] = useState<any>(null);
    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;

    const onChange: DatePickerProps['onChange'] = (date) => {
        var dateStr = date?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
        setNgayThang(date);
        if (dateStr) {
            setThangNam(dateStr);
            loadDSKPICaNhan(dateStr);
        } else {
            setThangNam("");
            loadDSKPICaNhan("");
        }
    }

    const loadDSKPICaNhan = async (thoiGian: any) => {
        setIsLoading(true);
        try {
            var data = await layDSKPICaNhan(thoiGian);
            setDataTable((data || []).map((v: any) => {
                return { ...v, key: v.idKPICaNhan }
            }));
        } catch (ex: any) {
            toast.error(ex);
        }

        setIsLoading(false);
    };

    const exportExcel = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatDanhGiaKetQuaKPI(id);
            let link = document.createElement('a');
            link.download = `BangDanhGiaKPI.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }
        dispatch(hideLoadingScreen());
    }

    const layCTKPICaNhan = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            var chiTiet = await layKPICaNhan(id)
            setChiTietKPICaNhan(chiTiet);
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }
        dispatch(hideLoadingScreen());
    }
    const componentRef = useRef(null);
    const printKPICaNhan = useReactToPrint({
        content: () => {
            return componentRef.current
        },
    });

    useEffect(() => {
        //loadDSKPICaNhan(thangHienTai);
        loadDSKPICaNhan("");
    }, [])

    useEffect(() => {
        if (!chiTietKPICaNhan) return;
        setTimeout(() => {
            printKPICaNhan();
        }, 300);
    }, [chiTietKPICaNhan])

    return (
        <>
            <section>
                <ContentHeader title="KPI Cá nhân" />
                <Row className="form-group" gutter={8}>
                    <Col span="6">
                        <DatePicker
                            changeOnBlur={true}
                            value={ngayThang}
                            style={{ width: "100%" }}
                            placeholder="Tháng đánh giá"
                            picker="month"
                            format={thangNamFormat}
                            onChange={onChange}
                        />
                    </Col>
                    <Col span="18">
                        {
                            menu[Links.KPI.ThemKPI] &&
                            <Link className="hrm-btn float-right hrm-btn-warning" to={Links.KPI.ChiTietKPI}><PlusOutlined rev="" />Thêm mới</Link>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <div className="card card-primary">
                            <Table
                                dataSource={dataTable}
                                loading={isLoading}
                                locale={{ emptyText: "Không có dữ liệu" }}
                            >
                                <Column title="Tháng" dataIndex="thangNam" key="thangNam" render={(value, record) => {
                                    var thangNam = dateCommon.getThangNam(value);
                                    return thangNam;
                                }} />
                                <Column title="Họ và tên" dataIndex="tenNhanVien" key="tenNhanVien" />
                                <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                                <Column title="Xếp loại" align="center" dataIndex="xepLoai" key="xepLoai" />
                                <Column title="Trạng thái" dataIndex="trangThai" key="trangThai" align="center" render={(value, record) => {
                                    return <TrangThaiTag value={record.trangThai} />
                                }} />
                                <Column title="Thao tác" dataIndex="action" key="action" render={(value: any, record: any) => {
                                    return (
                                        <>
                                            <Space>
                                                {menu[Links.KPI.ChiTietKPI] && user.idNhanVien == record.idNhanVien
                                                    ? <Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.KPI.ChiTietKPI + "?id=" + record.idKPICaNhan}><i><EyeOutlined rev="" /></i>Xem</Link>

                                                    : null
                                                }
                                                <Button
                                                    className="hrm-btn-print"
                                                    size="small"
                                                    icon=<PrinterOutlined rev="" />
                                                    onClick={() => { layCTKPICaNhan(record.idKPICaNhan); }}
                                                >In
                                                </Button>
                                                <Button
                                                    size="small"
                                                    className="hrm-btn float-left hrm-btn-success"
                                                    icon={<DownloadOutlined rev="" />}
                                                    onClick={() => { exportExcel(record.idKPICaNhan); }}
                                                >
                                                    Xuất excel
                                                </Button>
                                            </Space>
                                        </>
                                    )
                                }} />
                            </Table>
                        </div>
                    </Col>
                </Row>
            </section>
            {chiTietKPICaNhan != null &&
                <section style={{ display: 'none' }}>
                    <div ref={componentRef} >
                        <InKPICaNhan KPICaNhan={chiTietKPICaNhan} ></InKPICaNhan>
                    </div>
                </section>
            }
        </>
    );
};

export default KPICaNhan;